import { useEffect } from 'react';
import { Button } from '../../../../../../../components/button/button';
import { Input } from '../../../../../../../components/input/input';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { useLang } from '../../../../../../../hooks/use-lang';
import s from './menu-iiko-credentials-modal.module.css';
import { useIikoStore } from '../../../../../../../store/use-iiko-store';

export const MenuIikoCredentialsModal = (props: ModalProps) => {
  const { t } = useLang();
  const {
    fetchCredentials,
    postCredentials,
    putCredentials,
    credentials,
    handleUpdateCredentials,
  } = useIikoStore();

  useEffect(() => {
    fetchCredentials();
  }, []);

  const handleSave = async () => {
    try {
      if (credentials?.id) {
        await putCredentials();
      } else {
        await postCredentials();
      }
      props.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal className={s.feature} title={t('Ключи')} {...props}>
      <Input
        placeholder="apiLogin"
        value={credentials?.api_login}
        onChange={(e) => handleUpdateCredentials({ api_login: e.currentTarget.value })}
      />
      <Button onClick={handleSave}>{t('Сохранить')}</Button>
    </Modal>
  );
};
